import React, { useState } from 'react'
import { transactionTimeStamp } from '../../../utils'
import CheckBadgeIcon from '../../elements/icons/CheckBadgeIcon'
import ModalDialog from '../../layouts/ModalDialog'
import AddExamScore from './AddExamScore'
import ChangeExamCenter from './ChangeExamCenter'
import PencilSquareIcon from '../../elements/icons/PencilSquareIcon'
import UpdateExamScore from './UpdateExamScore'
import TrashIcon from '../../elements/icons/TrashIcon'
import { useDispatch } from 'react-redux'
import { updateApplicationExam } from '../../../store/actions/applicationsActions'

const ScheduledExamination = ({exam, application, reload }) => {
  const [addingExamScore, setAddingExamScore] = useState(false);
  const [changingCenter, setChangingCenter] = useState(false);
  const [updatingScore, setUpdatingScore] = useState(false);
  const dispatch = useDispatch()

  const cancelExam = () => {
    if(window.confirm(`This scheduled exam will be cancelled for the candidate. Are you sure you want to proceed?`)){
      dispatch(updateApplicationExam(application._id, {
        status: 'CANCELLED',
        examination: exam._id,
      }))
    }
  }
  
  return (
    <>
      <div className='my-5 p-3 bg-white rounded-[8px] bg-opacity-70 relative' >

          {!exam.examScore && <button onClick={()=>{setChangingCenter(true)}} className='absolute top-[5px] left-[5px] rounded-[8px] text-xs bg-transparent p-[5px] text-gray-600 transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2'>
            <PencilSquareIcon className='w-4 h-4' />
            Change Center
          </button>}
          {!exam.examScore && <button onClick={()=>{cancelExam()}} className='absolute top-[5px] right-[5px] rounded-[8px] text-xs bg-transparent p-[5px] text-gray-600 transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2'>
            <TrashIcon className='w-4 h-4' />
          </button>}
          <div className='w-full flex items-start justify-between gap-x-4 mt-[20px]'>
            <div className='w-[80%]'>
                <p className='text-gray-600'>{exam.examination.name}</p>
                <p className='text-xs text-gray-400'>{exam.examination.description}</p>
                {exam.center && exam.center !== '' && 
                  <p className='text-xs text-gray-800'>Center: {exam.center.name}</p>
                }
            </div>
            <div className='w-[20%]'>
                {exam.examScore && <p className={`p-2 rounded bg-opacity-10 font-orbitron ${exam.examScore < exam.examination.passingScore ? 'bg-red-500 text-red-500' : 'bg-green-500 text-green-500'}`}>{exam.examScore.toLocaleString()}%</p>}
                {exam.examScore && <button onClick={()=>{
                  setUpdatingScore(true)}
                  } className='text-xs mt-[5px] underline text-gray-500 text-right block hover:text-gray-300 transition duration-200'>Update</button>}
            </div>
          </div>

          {exam.status === 'ADMITTED' && 
          <p className='text-sm mt-1'>Written on {transactionTimeStamp(exam.dateAdmitted).date} - {transactionTimeStamp(exam.dateAdmitted).time}</p>
          }

          {exam.status !== 'ADMITTED' && !exam.examScore && <div className='w-full flex items-start justify-between gap-x-4 mt-5'>
            <button className='flex items-center gap-x-1 justify-center text-gray-600 p-1 text-xs hover:bg-gray-100 rounded transition duration-200'>
              Admit into exam 
            </button>
            <button onClick={()=>{setAddingExamScore(true)}} className='flex items-center gap-x-1 justify-center text-blue-600 text-xs rounded p-1 hover:bg-blue-100 hover:bg-opacity-50 transition duration-200'>
              <CheckBadgeIcon className={`w-5 h-5`} /> Add Score 
            </button>
          </div>}
      </div>


      <ModalDialog
        shown={addingExamScore} 
        closeFunction={()=>{setAddingExamScore(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Add Exam Score'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
          <AddExamScore 
            description={`Add examination score for ${application?.firstName} ${application?.lastName} for the examination ${exam.examination.name}`} 
            application={application}
            reload={()=>reload()}
            schedule={exam}
            closeFunction={()=>{setAddingExamScore(false)}} 
            examination={exam.examination}
          />
      </ModalDialog>

      <ModalDialog
        shown={updatingScore} 
        closeFunction={()=>{setUpdatingScore(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Update Exam Score'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
          <UpdateExamScore 
            description={`Update examination score for ${application?.firstName} ${application?.lastName} for the examination ${exam.examination.name}`} 
            application={application}
            reload={()=>reload()}
            closeFunction={()=>{setUpdatingScore(false)}} 
            schedule={exam}
            examination={exam.examination}
            currentScore={exam.examScore}
          />
      </ModalDialog>

      <ModalDialog
        shown={changingCenter} 
        closeFunction={()=>{setChangingCenter(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Change Examination Center'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <ChangeExamCenter 
          schedule={exam}
          exam={exam.examination}
          center={exam.center}
          application={application}
          closeFunction={()=>(setChangingCenter(false))}
          reload={()=>{reload()}}
        />
      </ModalDialog>
    </>
  )
}

export default ScheduledExamination